/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  Grid,
  Stack,
} from '@mui/material';
import {
  ChipSelectList,
  ChipOption,
  DebouncedSearchInput,
  MultiCountrySelector,
} from '@marageti/z4-lib';

type AllFiltersProps = {
  onChangeFilter: (name: string, v: string | string[]) => void;
  searchValue: string;
  selectedCountryCodes: string[];
  selectedStatusChips: string[];
  selectedTagChips: string[];
  statusChips: ChipOption[];
  tagChips: ChipOption[];
};

const AllFilters = ({
  onChangeFilter,
  searchValue,
  selectedCountryCodes,
  selectedStatusChips,
  selectedTagChips,
  statusChips,
  tagChips,
}: AllFiltersProps) => (
  <Box>
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <DebouncedSearchInput
          fullWidth
          key="fullText"
          label="Search"
          name="fullText"
          onChange={(v) => onChangeFilter('fullText', v)}
          defaultValue={searchValue}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <MultiCountrySelector
          key="countryOfResidence"
          label="Country of Residence"
          name="countryOfResidence"
          onChange={(e: React.SyntheticEvent, value: string[]) => onChangeFilter('countryOfResidence', value)}
          value={selectedCountryCodes}
        />
      </Grid>
    </Grid>
    <Stack direction={{ mobile: 'column', desktop: 'row' }} spacing={2} sx={{ mt: 1, mb: 4 }}>
      <ChipSelectList
        label="Tags"
        chipOptions={tagChips}
        selectedChips={selectedTagChips}
        onChange={(selectedChips) => onChangeFilter('tags', selectedChips)}
      />
      <ChipSelectList
        label="Status"
        chipOptions={statusChips}
        selectedChips={selectedStatusChips}
        onChange={(selectedChips) => onChangeFilter('status', selectedChips)}
      />
    </Stack>
  </Box>
);

export default AllFilters;
